module.exports = __webpack_public_path__ + "img/tools@2x.334f967.jpg";